

  /* Skin */
  .responsive3208187990__root .TextButton4166777016__root.TextButton4166777016---skin-8-standard {
    color: #116dff;
  }

  .responsive3208187990__root .TextButton4166777016__root.TextButton4166777016---skin-4-dark {
    color: #000624;
  }

  .responsive3208187990__root .TextButton4166777016__root.TextButton4166777016---skin-7-premium {
    color: #5a48f5;
  }

  /* Disabled */
  .responsive3208187990__root .TextButton4166777016__root.TextButton4166777016--disabled{
    color: #bebebe;
    cursor: initial;
  }

  /* Hover */
  .responsive3208187990__root .TextButton4166777016__root:not(.TextButton4166777016--disabled):hover.TextButton4166777016---skin-8-standard {
    color: #0f62e6;
  }

  .responsive3208187990__root .TextButton4166777016__root:not(.TextButton4166777016--disabled):hover.TextButton4166777016---skin-7-premium {
    color: #4D3DD0;
  }

/* st-namespace-reference="../../../../src/atoms/TextButton/TextButton.responsive.st.css" */